import { render, staticRenderFns } from "./InfoCheck.vue?vue&type=template&id=51e8a49d&scoped=true"
import script from "./InfoCheck.vue?vue&type=script&lang=js"
export * from "./InfoCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e8a49d",
  null
  
)

export default component.exports